import { useCallback, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Check, Camera, Loader2 } from "lucide-react";
import { Logo } from "@/components/shell/Logo";
import { api, messageErreur } from "@/lib/api";

export default function Depot() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [erreur, setErreur] = useState("");
  const [envoi, setEnvoi] = useState(null);
  const [message, setMessage] = useState("");
  const [enErreur, setEnErreur] = useState(false);
  const input = useRef(null);
  const cible = useRef("");
  const charger = useCallback(() => api.get(`/depot/${token}`).then((r) => setD(r.data)).catch((e) => setErreur(messageErreur(e))), [token]);
  useEffect(() => { charger(); }, [charger]);
  const choisir = (id) => { cible.current = id; input.current?.click(); };
  const envoyer = async (fichier) => {
    setEnvoi(cible.current || "autre"); setMessage("");
    const fd = new FormData(); fd.append("fichier", fichier); fd.append("piece_id", cible.current);
    try { const { data } = await api.post(`/depot/${token}`, fd); setEnErreur(false); setMessage(`Merci, « ${data.piece} » a bien été reçu.`); charger(); }
    catch (e) { setEnErreur(true); setMessage(messageErreur(e)); }
    setEnvoi(null);
  };
  return (
    <div className="min-h-screen px-4 py-6 max-w-lg mx-auto space-y-4" data-testid="page-depot">
      <Logo />
      {erreur && <p className="at-card p-5 font-semibold" data-testid="depot-error">{erreur}</p>}
      {d && (
        <>
          <h1 className="text-3xl font-bold tracking-tight" data-testid="depot-title">Bonjour {d.prenom}, envoyez vos documents</h1>
          <p className="at-muted">Dossier {d.operation}. Prenez une photo ou choisissez un PDF : il arrive directement dans votre dossier, sans créer de compte.</p>
          {message && <p className="at-card p-3 font-semibold" style={enErreur ? { background: "color-mix(in srgb, var(--danger) 12%, var(--surface))", color: "var(--danger)" } : undefined} data-testid="depot-message">{message}</p>}
          <div className="space-y-2">
            {[...d.pieces, { id: "", libelle: "Autre document", fournie: false }].map((p) => (
              <div key={p.id || "autre"} className="at-card p-4 flex items-center justify-between gap-3" data-testid={`depot-piece-${p.id || "autre"}`}>
                <p className="font-semibold flex items-center gap-2 min-w-0">{p.fournie && <Check size={16} style={{ color: "var(--success)" }} />}<span className="break-words">{p.libelle}</span></p>
                <button type="button" disabled={Boolean(envoi)} onClick={() => choisir(p.id)} className="at-btn at-btn-primary shrink-0 !px-3" data-testid={`depot-upload-${p.id || "autre"}`}>
                  {envoi === (p.id || "autre") ? <Loader2 size={16} className="animate-spin" /> : <Camera size={16} />}{p.fournie ? "Ajouter" : "Envoyer"}
                </button>
              </div>
            ))}
          </div>
          <input ref={input} type="file" accept="image/*,application/pdf" className="hidden" onChange={(e) => { if (e.target.files[0]) envoyer(e.target.files[0]); e.target.value = ""; }} data-testid="depot-file-input" />
          <p className="text-xs at-muted">Formats acceptés : photo (JPG, PNG, WEBP, HEIC) ou PDF, 15 Mo maximum.</p>
        </>
      )}
    </div>
  );
}
